<template>
  <b-container id="home" fluid>
    <b-row cols="10">
      <b-col>
        <h1 class="text-center mt-4">Win More, Win Better</h1>
        <h3 class="text-center">Get a 100% winrate for WarioWare Cat Game</h3>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col col xl="8">
        <p class="text-center">Thanks to generous donations from our loyal customers, we have been able to renovate <i>How To Win Wario Ware Cat Game</i> website in order to teach more people the secret to dominating all of their friendships with total Cat Game Victory.</p>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col col xl="8">
        <b-carousel
          id="mainpage-carousel"
          :interval="4000"
          indicators
          img-width="95pc"
          style="text-shadow: 1px 1px 2px #333"
        >
          <b-carousel-slide caption="Respect" text="Gain It." :img-src="require('../assets/fistbump.jpg')"></b-carousel-slide>
          <b-carousel-slide caption="Chance" text="Eliminate It.">
            <img
              slot="img"
              class="d-block img-fluid w-100"
              fluid-grow
              :src="require('../assets/luck.jpg')">
          </b-carousel-slide>
          <b-carousel-slide caption="Cat" text="Wake It." :img-src="require('../assets/cat.jpg')"></b-carousel-slide>
        </b-carousel>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col lg col xl="8">
        <b-card-group deck>
          <b-card
            header="** NEW **"
            title="Crawling Game"
            :img-src="require('../assets/crawling.png')"
            img-top
            bg-variant="dark"
            class="mt-3"
          >
            <b-card-text>
              We have expanded our range of expert advice thanks to new funding.
            </b-card-text>

            <b-btn variant="primary">Find Out More</b-btn>
          </b-card>
          <b-card
            title="Testimonials"
            :img-src="require('../assets/testimonial.jpg')"
            img-top
            bg-variant="dark"
            class="mt-3"
          >
            <b-card-text>
              Hear from our past and present customers before you get in touch with us to see just how useful we have been for the dozens of people who have committed to never losing the Wario Ware Cat Game ever again.
            </b-card-text>

            <b-btn variant="primary">See The Statements</b-btn>

          </b-card>
          <b-card
            title="Contact Us"
            :img-src="require('../assets/contact.jpg')"
            img-top
            bg-variant="dark"
            class="mt-3"
          >
            <b-card-text>
              Ready for the next stage? Just click below to get in touch and find out everything you need to never worry about losing the Wario Ware Cat Game to your friends.
            </b-card-text>

            <b-btn variant="primary">Get In Touch</b-btn>

          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'home',
  components: {
  }
}
</script>

<style scoped>
</style>
